import { graphql } from 'gatsby';
import ImageZoom from '@/components/ImageZoom';
import N5050BlockTextItem from '../N5050BlockTextItem/N5050BlockTextItem';
import {
  StyledImageContainer,
  StyledInfoContainer,
  StyledImageElement,
} from './N5050BlockImageAndTextRow.styles';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage';

const N5050BlockImageAndTextRow = ({
  n5050BlockImageTextRowElements: elements,
}: Queries.N5050_BLOCK_IMAGE_AND_TEXT_ROWFragment) => {
  const { image, image_direction, content, responsive_image, background_color } = elements;

  const imageValue = image?.value && {
    ...image.value,
    url: image.value.url,
    description: image.value.description ?? '',
    height: image.value.height!,
    width: image.value.width!,
  };

  const responsiveImageValue = responsive_image?.value && {
    ...responsive_image.value,
    url: responsive_image.value.responsiveImageElements.desktop.value.url,
    description: responsive_image.value.responsiveImageElements.desktop.value.description ?? '',
    height: responsive_image.value.responsiveImageElements.desktop.value.height!,
    width: responsive_image.value.responsiveImageElements.desktop.value.width!,
  };

  const backgroundValue = background_color?.value ?? undefined;

  return (
    <>
      <StyledInfoContainer direction={image_direction.value} backgroundValue={backgroundValue}>
        <N5050BlockTextItem {...content.value} />
      </StyledInfoContainer>
      <StyledImageContainer direction={image_direction.value}>
        {responsiveImageValue ? (
          <ResponsiveImage {...responsiveImageValue} fit="contain" />
        ) : (
          imageValue && (
            <ImageZoom width={imageValue.width}>
              <StyledImageElement
                alt={imageValue.description}
                height={imageValue.height}
                width={imageValue.width}
                image={{ ...imageValue, image_id: imageValue.url }}
              />
            </ImageZoom>
          )
        )}
      </StyledImageContainer>
    </>
  );
};
export default N5050BlockImageAndTextRow;

export const fragment = graphql`
  fragment N5050_BLOCK_IMAGE_AND_TEXT_ROW on kontent_item_n5050_block_image_and_text_row {
    system {
      id
    }
    n5050BlockImageTextRowElements: elements {
      image {
        value {
          width
          url
          type
          height
          name
          description
        }
      }
      responsive_image {
        value {
          ...RESPONSIVE_IMAGE
        }
      }
      image_direction {
        value
      }
      content {
        value {
          ...N5050_BLOCK_TEXT_ITEM
        }
      }
      background_color {
        value
      }
    }
  }
`;
